// echarts中px转换rem
export function fontSize(res:any) {
    // eslint-disable-next-line no-unused-vars
    let docEl = document.documentElement,
        clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    if (!clientWidth) return;
    let fontSize = 20 * (clientWidth / 1920);
    return res * fontSize;
}